// js/shared/handlers/handleUiClick.js
import { domExtensions } from '/js/shared/extensions/domExtensions.js';

export function handleUiClick(event) {
	domExtensions.handleUiClick(event);
}
